/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ExtendedVcdsServiceTypeEnum = 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR' | 'VMC';

export const ExtendedVcdsServiceTypeEnum = {

    VCDS: 'VCDS' as ExtendedVcdsServiceTypeEnum,

    VCDR: 'VCDR' as ExtendedVcdsServiceTypeEnum,

    VMCFS: 'VMCFS' as ExtendedVcdsServiceTypeEnum,

    SRM: 'SRM' as ExtendedVcdsServiceTypeEnum,

    VSR: 'VSR' as ExtendedVcdsServiceTypeEnum,

    VMC: 'VMC' as ExtendedVcdsServiceTypeEnum
};

